<template>
  <div :class="$style.currentLevelRewardsListCard">
    <div :class="$style.currentLevelRewardsListCardImg">
      <img :src="reward.icon.url" />
    </div>
    <span>{{ reward.title }}</span>
    <span v-if="reward.value" :class="$style.currentLevelRewardsListCardValue">
      {{ snippet.format(reward.value) }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import type { TvipReward } from '~/types/vip';

defineProps({
  reward: {
    type: Object as PropType<TvipReward>,
    required: true,
  },
});

const snippet = useSnippet();
</script>

<style lang="scss" module src="./vipRewardCard.scss"></style>
